import React, { useMemo } from 'react';
import { useRequest } from 'ahooks';
import GamePillar from '@gp/pages/Pipeline/ProjectDetails/GameDetail/components/GamePillar';
import ElevatorPitch from '@gp/pages/Pipeline/ProjectDetails/GameDetail/components/ElevatorPitch';
import VisualShowcase from '@gp/pages/Pipeline/ProjectDetails/GameDetail/components/VisualShowcase';
import SimilarGames from '@gp/pages/Pipeline/ProjectDetails/GameDetail/components/SimilarGames';
import TeamGameInformation from '@gp/pages/Pipeline/ProjectDetails/GameDetail/components/TeamGameInformation';
import '@gp/assets/css/pages/projectDetail.css';
import './index.scss';
import { getCountryFlags } from '@/pages/globalpedia/services/global';
import useAutoScroll2TargetModule from '../_hooks/useAutoScroll2TargetModule';
import usePageLog from '@gp/hooks/usePageLog';

export default function ProjectDetail(props: any) {
  const {
    pageContainer,
    milestoneData,
    visualcaseData,
    visualcaseLoading,
    similarData,
    similarLoading,
    gameInformationData,
    gameInformationLoading,
    gameInformationDataRefresh,
    similarDataRefresh,
    visualCaseDataRefresh,
    // 是否有编辑权限
    userIsAbleEdit,
    gamePillarData,
    gamePillarLoading,
    getGamePillarRefresh,
    elevatorPitchData,
    elevatorPitchLoading,
    getElevatorPitchRefresh,
  } = props;

  const { data: allCountryFlag = {} } = useRequest(getCountryFlags);

  const rightIconEdit = useMemo(() => {
    return [
      {
        isText: true,
        icon: 'pencil-m',
        context: 'Edit',
        isShow: userIsAbleEdit,
      },
    ].filter((task) => task.isShow);
  }, [userIsAbleEdit]);

  useAutoScroll2TargetModule({
    pageContainer,
    loading: gameInformationLoading || visualcaseLoading || similarLoading,
  });

  usePageLog({
    pageId: 'PIPELINE_DETAIL',
    uidType: 'game_code',
    uid: gameInformationData?.project_id || '',
    extInfo: gameInformationData?.project || '',
  });

  return (
    <div className="dbg-project-gamedetails-detail-content">
      <GamePillar
        gameInformationData={gameInformationData}
        resData={gamePillarData}
        loading={gamePillarLoading}
        refreshFun={getGamePillarRefresh}
        userIsAbleEdit={userIsAbleEdit}
        iconList={rightIconEdit}
      />

      <div className="dbg-project-detail_horizontal-section dbg-project-detail_first-horizontal-section">
        <ElevatorPitch
          gameInformationData={gameInformationData}
          resData={elevatorPitchData}
          loading={elevatorPitchLoading}
          refreshFun={getElevatorPitchRefresh}
          userIsAbleEdit={userIsAbleEdit}
          iconList={rightIconEdit}
        />

        <TeamGameInformation
          gameInformationData={gameInformationData}
          loading={gameInformationLoading}
          refreshFun={gameInformationDataRefresh}
          userIsAbleEdit={userIsAbleEdit}
          iconList={rightIconEdit}
        />
      </div>

      <VisualShowcase
        gameInformationData={gameInformationData}
        loading={visualcaseLoading}
        refreshFun={visualCaseDataRefresh}
        userIsAbleEdit={userIsAbleEdit}
        iconList={rightIconEdit}
        visualcaseData={visualcaseData}
        milestoneData={milestoneData}
      />

      <SimilarGames
        gameInformationData={gameInformationData}
        loading={similarLoading}
        refreshFun={similarDataRefresh}
        userIsAbleEdit={userIsAbleEdit}
        iconList={rightIconEdit}
        similarData={similarData}
        allCountryFlag={allCountryFlag}
      />
    </div>
  );
}
